import { render, staticRenderFns } from "./MyClassDetailOverview.vue?vue&type=template&id=d58f9e04&scoped=true&"
import script from "./MyClassDetailOverview.vue?vue&type=script&lang=ts&"
export * from "./MyClassDetailOverview.vue?vue&type=script&lang=ts&"
import style0 from "./MyClassDetailOverview.vue?vue&type=style&index=0&id=d58f9e04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58f9e04",
  null
  
)

export default component.exports